import React from "react";
import PropTypes from "prop-types";

const Recipients = ({ data }) => (
  <div style={{ marginBottom: 15 }}>
    {data.map((item, index) => (
      <span key={index} style={{ paddingRight: 5, display: "inline-block" }}>
        <span className="label label-default">{item}</span>
      </span>
    ))}
  </div>
);

Recipients.proptTypes = {
  data: PropTypes.array
};

export default Recipients;
